import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'misc-content-details',
		path: '/l/:countryCode/p/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/misc_content_details" */ './index'), {
			exportName: 'MiscContentDetails',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
			config: {
				disallowUserData: true,
				cache: {
					enabled: true,
					lifetimeInSeconds: 5 * 60,
				},
			},
		},
	},
];
